import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Typography } from "material-ui";
import UserAvatar from "./UserAvatar";
import { grey } from "material-ui/colors";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    flex: {
        display: "flex",
        alignItems: "center"
    },
    newPostMessage: {
        flex: 1,
        color: grey[300],
        fontWeight: 200,
        cursor: "text"
    },
    content: {
        padding: `${theme.spacing.unit * 1.5}px ${theme.spacing.unit *
            1.5}px  ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 2}px `
    },
    card: {
        cursor: "pointer"
    }
});

class NewPostCard extends Component {
    render() {
        const {
            t,
            currentUser: { displayName, avatarURL },
            classes
        } = this.props;
        return (
            <Card
                elevation={1}
                className={classes.card}
                onClick={this.props.onClick}>
                <CardContent
                    style={{ paddingBottom: 12 }}
                    className={classes.content}>
                    <div className={classes.flex}>
                        <UserAvatar
                            displayName={displayName}
                            avatarURL={avatarURL}
                        />
                        <Typography
                            className={classes.newPostMessage}
                            type="title">
                            {t("newPostCard.What's on your mind?")}
                        </Typography>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

NewPostCard.propTypes = {
    classes: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    t: PropTypes.func.isRequired
};

NewPostCard.defaultProps = {
    onClick: () => {}
};

export default withStylesAndTranslation(NewPostCard, styleSheet);



// WEBPACK FOOTER //
// ./src/components/NewPostCard.jsx